import type Parse from "parse";

import { Role } from "@telespot/domain";

import { ParseMapper } from "../../parse.mapper";
import { ObjectTopology } from "../../parse.topology";

export enum RoleTopology {
  USERS = "users",
  NAME = "name",
  TABLE = "_Role",
}

export class ParseRoleMapper extends ParseMapper {

  /**
   * Maps an existing role (with ID) to a Parse.Role.
   * Trying to map an unsaved role will result in an error.
   *
   * @param role an existing role entity
   * @returns
   */
  public fromDomain(role: Role): Parse.Role {
    if (!role.id) throw new Error("Unsaved role!")

    const parseRole = this.parse.Role.fromJSON({
      className: RoleTopology.TABLE,
      [ObjectTopology.ID]: role.id,
      [RoleTopology.NAME]: role.name,
    });

    const addedUsers = role.grantedUserIds.map(id => this.parse.User.createWithoutData(id));
    const removedUsers = role.revokedUserIds.map(id => this.parse.User.createWithoutData(id));

    parseRole.getUsers().add(addedUsers);
    parseRole.getUsers().remove(removedUsers);

    return parseRole;
  }

  public toDomain(parseRole: Parse.Role): Role {
    return new Role({
      id: parseRole.id,
      name: parseRole.getName(),
    });
  }
}
